import { useEffect } from 'react';
import FadeIn from '../../../components/Animation/FadeIn';
import CardProfile from '../../../components/Card/Profile';
import { Briefcase } from '../../../components/CustomIcon';
import { ProgressCircle } from '../../../components/Progress/Circle';
import DashboardPublicLinks from './Links';
import DashboardPublicSoftwares from './Softwares';
import { RoutePaths } from '../../../config/routes';
import { useNavigate, useOutletContext } from 'react-router-dom';
import DashboardPublicMusicalGenres from './MusicalGenres';
import DashboardPublicDescription from './Description';
import { useUser } from '../../../hooks/useUser';
import DashboardPublicCollaborations from './Collaborations';
import DashboardPublicLanguages from './Languages';
import DashboardPublicSkills from './Skills';
var DashboardPublic = function () {
    var _a;
    var user = useOutletContext().user;
    var isDone = useUser().isDone;
    var navigate = useNavigate();
    var progressPercentage = useUser().progressPercentage;
    useEffect(function () {
        var _a;
        if (((_a = user === null || user === void 0 ? void 0 : user.category) === null || _a === void 0 ? void 0 : _a.slug) == 'visitor') {
            navigate(RoutePaths.DASHBOARD_PROFILE);
        }
    }, []);
    if (((_a = user === null || user === void 0 ? void 0 : user.category) === null || _a === void 0 ? void 0 : _a.slug) == 'visitor')
        return null;
    return (<FadeIn>
      <div className="mt-4 mb-10 grid gap-6 md:mt-10 lg:grid-cols-2">
        {progressPercentage() < 100 && (<div className="flex rounded-lg bg-white p-4 shadow-lg md:mb-2 lg:col-span-2">
            <ProgressCircle percentage={progressPercentage()}/>
            <div className="ml-6 flex flex-1 flex-col">
              <p className="p font-medium">
                Vous avez complété {progressPercentage()}% de votre profil
              </p>
              <p className="text-xs text-gray-700">
                Remplissez les rubriques suivantes et faites en sorte d'améliorer votre visibilité.
              </p>
            </div>
          </div>)}

        <DashboardPublicSkills />

        <DashboardPublicLanguages />

        <CardProfile title="Mes expériences" description="Mission, formation, événement, bénévolat, intervention, création... Détaillez vos expériences." filled={isDone('experiences')} icon={Briefcase} onClick={function () {
            navigate(RoutePaths.DASHBOARD_EXPERIENCE);
        }}/>

        <DashboardPublicCollaborations />

        <DashboardPublicMusicalGenres />

        <DashboardPublicDescription />

        <DashboardPublicSoftwares />

        <DashboardPublicLinks />
      </div>
    </FadeIn>);
};
export default DashboardPublic;
